import NewspaperNewsTips from './NewspaperNewsTips'
export default NewspaperNewsTips
